import {React, useState} from 'react';
import styles from './SmallPersonCard.module.scss';
import VideoRecorder from "@untitled-ui/icons-react/build/cjs/VideoRecorder";
import Mail01 from "@untitled-ui/icons-react/build/cjs/Mail01";
import Share06 from "@untitled-ui/icons-react/build/cjs/Share06";
import VideoRecorderOff from "@untitled-ui/icons-react/build/cjs/VideoRecorderOff";
import classes from './SmallPersonCard.module.scss';
import blankprofileImage from 'images/blank-profile-picture.png'


const SmallPersonCard = (props) => {

    const handleMessageClick = () => {
        props.onMessage();
    };

    const handleShareClick = () => {
        props.onShare();
    };

    return (
        <div className={`${styles.cardContainer} ${props.isSelected ? styles.selected : ''}`} onClick={props.onSelect}>
            <div className={styles.leftSection}>
                <div className={styles.profileSection}>
                    <div className={classes.profileCircle} style={{ backgroundImage: `url(${props.avatar || blankprofileImage})` }} />
                    <div className={styles.nameTitle}>
                        <div className={styles.name}>{props.displayName}</div>
                        <div className={styles.title}>{props.title}</div>
                    </div>
                </div>
                {
                    <div className={styles.tags}>
                        {props.skill && <span className={styles.skill}>{props.skill}</span>}
                        {props.expertise && <span className={styles.expertise}>{props.expertise}</span>}
                    </div>
                }
                <div className={styles.goal}>I want to {props.goal}</div>
                {
                    props.introduction && (
                        <div className={styles.introduction}>{props.introduction}</div>
                    )
                }
            </div>
            <div className={styles.rightSection}>
                {
                    props.userVideo ? (
                        <a className={classes.iconButton}> <VideoRecorder /> </a>
                    ) : (
                        <a className={classes.disabledIconButton}> <VideoRecorderOff /> </a>
                    )
                }
                <a className={classes.iconButton} onClick={() => { handleMessageClick() }}> <Mail01 /> </a>
                <a className={classes.iconButton} onClick={() => { handleShareClick() }}> <Share06 /> </a>
            </div>
        </div>
    );
};

export default SmallPersonCard;
